<template>
  <div>
    <v-row align="center">
      <v-col cols="3">
        <v-text-field v-model="value.dynamic_qrcode_key" :error-messages="dynamic_qrcode_error" label="不定额收款码ID"
          hint="点击右侧上传按钮" class="required"></v-text-field>
      </v-col>
      <v-col cols="7">
        <FileUpload v-model="value.dynamic_qrcode_value" @upload="onUploadDynamicQrcode">上传收款码</FileUpload>
      </v-col>
      <v-col cols="2">
        <v-btn icon depressed @click="onPreviewDynamicQrcode">
          <v-icon>{{ mdiImage }}</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <v-row align="center" :key="index" v-for="(_, index) in value.static_qrcode_list">
      <v-col cols="2">
        <InputMoneyField label="金额/元" class="required" currency="CNY" v-model="value.static_qrcode_list[index].amount" />
      </v-col>
      <v-col cols="2">
        <v-text-field label="收款码" hint="右侧上传按钮" v-model="value.static_qrcode_list[index].qrcode_key"></v-text-field>
      </v-col>
      <v-col cols="5">
        <FileUpload v-model="value.static_qrcode_list[index].qrcode_value"
          @upload="({ files, done }) => onUploadStaticQrcode({ index, files, done })">上传收款码</FileUpload>
      </v-col>
      <v-col cols="1">
        <v-btn icon depressed @click="onPreviewStaticQrcode(index)">
          <v-icon>{{ mdiImage }}</v-icon>
        </v-btn>
      </v-col>
      <v-col cols="1">
        <v-btn icon depressed @click="onDeleteStaticQrcode(index)">
          <v-icon>{{ mdiDelete }}</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <v-btn depressed @click="onAddStaticQrcode">
      <v-icon>{{ mdiPlus }}</v-icon>
      <span>定额收款码</span>
    </v-btn>
  </div>
</template>

<script>
import _ from 'lodash'
import { mdiDelete, mdiPlus, mdiUpload, mdiChevronRight, mdiImage } from '@mdi/js'
import { API } from '@/plugins/api'
import InputMoneyField from '@/components/InputMoneyField.vue'
import FileUpload from '@/components/FileUpload.vue'

export default {
  components: { InputMoneyField, FileUpload },
  model: {
    prop: 'value',
    event: 'input',
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      mdiDelete,
      mdiPlus,
      mdiUpload,
      mdiChevronRight,
      mdiImage,
      dynamic_qrcode_error: null,
    }
  },
  computed: {},
  methods: {
    onAddStaticQrcode() {
      this.value.static_qrcode_list.push({
        qrcode_key: null,
        qrcode_value: null,
        amount: null,
      })
    },
    onDeleteStaticQrcode(index) {
      this.value.static_qrcode_list.splice(index, 1)
    },
    async onUploadDynamicQrcode({ files, done }) {
      try {
        let result = await API.upload('merchant/qrcode.upload', files[0])
        this.value.dynamic_qrcode_key = result.key
        this.value.dynamic_qrcode_value = result.qrcode_value
        this.dynamic_qrcode_error = null
      } finally {
        done()
      }
    },
    async onUploadStaticQrcode({ index, files, done }) {
      try {
        let result = await API.upload('merchant/qrcode.upload', files[0])
        let item = this.value.static_qrcode_list[index]
        item.qrcode_key = result.key
        item.qrcode_value = result.qrcode_value
      } finally {
        done()
      }
    },
    async _previewResource(key) {
      if (_.isNil(key) || key === '') {
        return
      }
      let result = await API.call('resource.token', { key: key })
      let path = API.urlForImage({ key, token: result['token'] })
      window.open(path, '_blank')
    },
    onPreviewDynamicQrcode() {
      this._previewResource(this.value.dynamic_qrcode_key)
    },
    onPreviewStaticQrcode(index) {
      let item = this.value.static_qrcode_list[index]
      this._previewResource(item.qrcode_key)
    },
  },
}
</script>

<style lang="less" scoped></style>
